import { render } from "./About.vue?vue&type=template&id=24d15915&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=24d15915&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kedaq\\Desktop\\pruebaBodyTech\\pruebaspotify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d15915"]])

export default __exports__